module.exports = __webpack_public_path__ + "img/support_prot_mb_1.94d0467a.jpg";